import { StaffMemberStore, StaffMemberStoreInterface } from '@/shared/infrastructure/store/StaffMemberStore';
import { getStore, usePlocState } from '@hfc/ui-core';

interface UseStaffMemberStoreInterface {
  staffMemberStore: StaffMemberStore;
  staffMemberState: ReturnType<typeof usePlocState<StaffMemberStoreInterface>>
}

export function useStaffMemberStore (): UseStaffMemberStoreInterface {
  const staffMemberStore = getStore<StaffMemberStore>('StaffMemberStore', StaffMemberStore);
  const staffMemberState = usePlocState(staffMemberStore);

  return {
    staffMemberStore,
    staffMemberState
  };
}
